module.exports = __webpack_public_path__ + "img/dex.c91d700f.svg";